import { calculateInlineScore, iterateStylesheets, sortScores } from ".";

function resolveScorePool(element, property) {
  var scores = []; // Iterate all our stylesheets

  iterateStylesheets(element, scores, property); // Calculate by inline style

  var inline = calculateInlineScore(element, property);
  inline && scores.push(inline); // Prepare result

  if (!scores.length) {
    return undefined;
  } // Sort scores


  sortScores(scores);
  return scores;
}

export { resolveScorePool };